export const getMapBoundsByPathName = pathName => {
  if (!pathName) { return null }

  const pathNameArray = pathName.split('/')
  const mapBoundsIndex = pathNameArray.findIndex(item => item === 'map-bounds')

  if (mapBoundsIndex < 0) { return null }

  const mapBounds = {
    east: Number(pathNameArray[mapBoundsIndex + 4]),
    north: Number(pathNameArray[mapBoundsIndex + 3]),
    south: Number(pathNameArray[mapBoundsIndex + 1]),
    west: Number(pathNameArray[mapBoundsIndex + 2])
  }

  return mapBounds
}
